module.exports = __webpack_public_path__ + "img/admin-1.0f31e779.jpg";